module.exports = __webpack_public_path__ + "img/中通智能.7a37be39.png";